import animationData from '@animations/succesAnimation.json';
import { Flex, Modal, ModalBody, ModalContent, ModalOverlay } from '@chakra-ui/react';
import Body1 from '@components/typography/Body1';
import Header from '@components/typography/Header';
import Lottie from 'lottie-react';
import { useRef } from 'react';

const SuccessModal = ({ isOpen, setIsOpen }) => {
  const animationRef = useRef(null);
  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        size="2xl"
        closeOnEsc={false}
        closeOnOverlayClick={false}
        isCentered
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalBody />
          <Flex h="20%" w="20%" m="auto">
            <Lottie lottieRef={animationRef} loop={false} animationData={animationData} />
          </Flex>
          <Header as="h2" color="primary.500" textAlign="center">
            Welcome to Bedrock
          </Header>
          <Header as="h3" mb={5} textAlign="center">
            We just sent a secure sign in link to your email.
          </Header>
          <Body1 mb={10} textAlign="center">
            You can now close this window.
          </Body1>
        </ModalContent>
      </Modal>
    </>
  );
};

export default SuccessModal;
